import * as PropTypes from 'prop-types';
import React from 'react';

export function TenantName({tenant}) {
    return <>{tenant?.fullName}</>;
}

TenantName.propTypes = {tenant: PropTypes.any};